import React, { Component } from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Quagga from "quagga";

const UPDATE_CARD_ENDPOINT = "https://qibipay.azurewebsites.net/api/CardUpdate";

class AddDeviceModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - logout

             - tableRef
             - globalConfig

             - *cardId
        */
        super(props);

        this.state = {
            errors: {

            },

            loading: false,
            success: false,

            cardId: ""
        }
    }

    async submit() {
        if((this.props.cardId!=null || this.idRef.validated()) && this.creditRef.validated()) {
            this.setState({loading: true, errors:{}, errorMessage:null});

            const toAdd = parseFloat(this.creditRef.value);

            const options = {
                method: 'POST',
                uri: UPDATE_CARD_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    credit: toAdd,
                    card_id: this.props.cardId!=null ? this.props.cardId : this.idRef.value
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body.msg});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            this.setState({
                success: true
            });

            //Success
            for(let row of this.props.tableRef.getAllData()) {
                if(this.props.cardId==null ? row.cardId===this.idRef.value : row.cardId===this.props.cardId) {
                    this.props.tableRef.resetTable();
                    break;
                }
            }
        }
    }

    async submitSubtract() {
        if((this.props.cardId!=null || this.idRef.validated()) && this.creditRef.validated()) {
            this.setState({loading: true, errors:{}, errorMessage:null});

            const toAdd = parseFloat(this.creditRef.value);

            const options = {
                method: 'POST',
                uri: UPDATE_CARD_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    credit: -toAdd,
                    card_id: this.props.cardId!=null ? this.props.cardId : this.idRef.value
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            this.setState({
                success: true
            });

            //Success
            for(let row of this.props.tableRef.getAllData()) {
                if(this.props.cardId==null ? row.cardId===this.idRef.value : row.cardId===this.props.cardId) {
                    this.props.tableRef.resetTable();
                    break;
                }
            }
        }
    }

    reset() {
        this.setState({
            errors: {

            },

            loading: false,
            success: false,
            cardId: ""
        });
        this.props.onClose();
    }

    componentWillUnmount() {
        Quagga.offDetected(this.onDetected);
    }

    initQuagga() {
        console.log("scan element",document.querySelector('#scanElement'));
        Quagga.init({
            inputStream : {
                name : "Live",
                type : "LiveStream",
                target: document.querySelector('#scanElement')
            },
            decoder : {
                readers : ["code_128_reader"]
            }
        }, function(err) {
            if (err) {
                console.log(err);
                document.getElementById("scanElement").style.display = "none";
                return
            }
            document.getElementById("scanElement").style.display = "block";
            console.log("Initialization finished. Ready to start");
            Quagga.start();
        });

        Quagga.onDetected(this.onDetected.bind(this));
    }

    onDetected(result) {
        const errors = result.codeResult.decodedCodes
            .filter(_ => _.error !== undefined)
            .map(_ => _.error);
        const median = this.getMedian( errors );

        if (median < 0.10)
            this.onCompleteScanned(result);
    }

    onCompleteScanned(result) {
        this.setState({
            cardId: result.codeResult.code
        })

        this.handleModalClose();

        if (this.bCompleteScanned) return;
        this.bCompleteScanned = true;

        if(this.props.onCompleteScanned!=null) this.props.onCompleteScanned(result.codeResult.code);
    }

    getMedian(arr) {
        arr.sort((a, b) => a - b);
        const half = Math.floor( arr.length / 2 );
        if (arr.length % 2 === 1) // Odd length
            return arr[ half ];
        return (arr[half - 1] + arr[half]) / 2.0;
    }

    componentDidUpdate() {
        if(this.props.open) {
            if (this.opened === false || this.opened == null) {
                if(this.props.cardId==null) {
                    this.initQuagga();
                    this.opened = true;
                }
            }
        } else {
            if (this.opened === true) {
                this.handleModalClose();
                this.opened = false;
            }
        }

    }

    handleModalClose() {
        Quagga.stop();
        Quagga.offDetected(this.onDetected);
        document.getElementById("scanElement").style.display = "none";
    }

    render() {
        return(
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                }
            }} >
                <h2>Quick Credit</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}

                {this.state.loading ? (
                    <div>
                        <p>Subtracting/Adding credit to card...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Credit added/subtracted successfully!</p>
                    </div>
                ) : (
                    <Form horizontal style={{
                        marginLeft: "32px",
                        marginRight: "32px"
                    }}>
                        <div id="scanElement"></div>
                        {this.props.cardId==null ? (
                            <ValidatedFormComponent name="Identification"
                                                    type="text"
                                                    placeholder="Enter card ID"
                                                    onValidate={input => {
                                                        if(!/^[0-9]*$/.test(input)) return "Card identification can only contain numbers!";
                                                        return null;
                                                    }}
                                                    onChange={(val) => {this.setState(
                                                        {
                                                            cardId: val
                                                        }
                                                    )}}
                                                    value={this.state.cardId}
                                                    inputRef={ref => this.idRef=ref}
                            />
                        ) : ""}
                        <ValidatedFormComponent name="Credit to add/subtract"
                                                type="number"
                                                decimal
                                                min={0}
                                                step={0.01}
                                                placeholder="Enter credit to add/subtract"
                                                onValidate={input => {
                                                    return null;
                                                }}
                                                inputRef={ref => this.creditRef=ref}
                                                />
                        <Col sm={1}/>
                        <Col sm={4} componentClass={Button} className="btn-primary" onClick={this.submit.bind(this)}>
                            Add Credit
                        </Col>
                        <Col sm={2}/>
                        <Col sm={4} componentClass={Button} className="btn-danger" onClick={this.submitSubtract.bind(this)}>
                            Subtract Credit
                        </Col>
                        <Col sm={1}/>
                    </Form>
                )}
            </Modal>
        );
    }

}

export default AddDeviceModal;